import {animated} from 'react-spring';

import styled, {css} from 'styled-components';

import BaseCloseIcon from '@edna/icons/close.svg';

import {mixins} from '../styles';
import {ENotificationType, TNotification} from './types';

type TItemProps = TTheme & {
  type: TNotification['type'];
};

export const Notifications = styled.div`
  ${mixins.position({position: 'fixed', bottom: '24px', right: '0'})}
  z-index: ${({theme}) => theme.zIndex.notifications};
`;

const getItemColorStyle = ({type, theme: {branding}}: TItemProps) => {
  switch (type) {
    case ENotificationType.success:
      return branding.colors.success;
    case ENotificationType.warning:
      return branding.colors.warning;
    case ENotificationType.error:
      return branding.colors.error;
    case ENotificationType.info:
    default:
      return branding.colors.disabled;
  }
};

export const ItemWrapper = styled.div`
  padding: ${({theme: {spacing}}) => `0 ${spacing.s6} ${spacing.s4} 0`};
`;

export const Item = styled.div`
  position: relative;
  overflow: hidden;
  ${mixins.flexAlign('flex-start')}
  width: 30em;
  ${({theme}) => css`
    padding: ${theme.spacing.s4};
    background-color: ${theme.palette.white};
    border-radius: ${theme.borderRadius.br1} ${theme.borderRadius.br1} 0 0;
    box-shadow: ${theme.boxShadow.notification};
  `}
`;

export const Header = styled.div`
  margin-right: ${({theme}) => theme.spacing.s4};
`;

export const Icon = styled.svg<TItemProps>`
  ${mixins.wh('20px')}
  flex-shrink: 0;
  margin-right: ${({theme}) => theme.spacing.s4};
  fill: ${getItemColorStyle};
`;

export const CloseButton = styled.button`
  ${mixins.wh('20px')}
  ${mixins.pureButton}
  ${mixins.flexAlign('center')}
  margin-left: auto;
  color: ${({theme}) => theme.palette.grey900};
`;

export const CloseIcon = styled(BaseCloseIcon)`
  ${mixins.wh('16px')}
`;

export const Title = styled.div`
  ${mixins.f4}
  letter-spacing: 0.53px;
`;

export const Message = styled.div`
  letter-spacing: 0.26px;
`;

export const Life = styled(animated.div)<TItemProps>`
  ${mixins.position({position: 'absolute', left: 0, bottom: 0})}
  height: 3px;
  background-color: ${getItemColorStyle};
`;
